
```
<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-lg">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="row">
                            <p class="nonprofit-modal-msg">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="registration-title">
                                        <div>
Adopt-a-School Today!
                                        </div>
                                        </div>
                                    </div>
                                    <div class=" padding-left col-lg-11 col-md-12 col-sm-12 col-xs-12">
        <p class=""><b>Adopt-a-School</b> and we’ll provide free glasses for kids in need! </p>
        <p class="">Millions of students don't have the glasses they need because their families cannot access or afford vision care.</p>
        <p class="">To bridge this gap, the OneSight EssilorLuxottica Foundation encourages eye doctors to enroll in Changing Life through Lenses (CLTL) to access free glasses and Adopt-a-School to provide local students the vision care they deserve.</p>
        <p class="">You can <b>Adopt-a-School</b> and support your community in 3 easy steps: </p>
  <div class="container">
  <div class="row">
    <div class="col-sm text-center">
     <img src="/static/assets/img/CLTLDay/Step1.png">
      <br/>
      <br/>
      <b>Click <b>Pledge Today!</b> below and pledge to support a local school  </b>
    </div>
    <div class="col-sm text-center">
      <img src="/static/assets/img/CLTLDay/Step2.png">
      <br/>
      <br/>
      <b>Contact a local school in need using CLTL’s Adopt-a-School resources</b>
    </div>
    <div class="col-sm text-center">
      <img src="/static/assets/img/CLTLDay/Step3.png">
      <br/>
      <br/>
      <b>Serve students with the support of CLTL’s free glasses</b>
    </div>
  </div>
</div>
      <br/>
        <p class="">CLTL's Adopt-a-School resources help you partner with schools by offering: email templates to contact the schools, talking points to speak with the nurses and customizable flyers for parent referrals
        <!--<ul><li>Email template for introduction to the school 
<li>Talking points to establish a partnership with the nurse </li>
<li>Customizable flyer to pass on to parents for referrals </li></ul>--></p>
        <p class=""><i>Doctors who sign up for Changing Life through Lenses may be invited to join a OneSight EssilorLuxottica Foundation vision clinic!</i></p>
        <p class="">Pledge today and help a student be more and see more!</p>
                                    </div>
                  </div>
                  </div>
                </div>
                <loading-component v-if="isFormLoading"></loading-component>
                <br/>
                <br/>
                <div class="row">
                    <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center">
                        <button @click="SubmitCRPS('yes')" type="button" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Pledge Today!</button>
                        <button @click="SubmitCRPS('remindLater')" type="button" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Remind Me Later</button>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <!--<div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center">
                        <button @click="SubmitCRPS('enrolledAlready')" type="button" class="btn bg-transparent text-danger g-font-size-16"><u>I already pledged (do we need this?)</u></button>
                    </div>-->
                    <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center">
                        <button @click="SubmitCRPS('no')" type="button" class="btn bg-transparent text-danger g-font-size-16"><u>Not Interested or Unable to Participate</u></button>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CovidRelief from "@/components/AccountDetails/CovidRelief";
import LoadingComponent from "@/components/shared/LoadingComponent";
export default {
  props: [],
  components: {
    CovidRelief,
    LoadingComponent
  },
  data() {
    return {
      Account: null,
      isFormLoading: false,
      isModalShown: true,
//CovidReliefParticipantStatus: '',
    }
  },
  methods: {
    CloseModal() {
      this.$emit('CtlModalForm');
    },
    SubmitCRPS(CovidReliefParticipantStatus) {
      var _this = this;
      _this.isFormLoading = true;
      axios
        .post("/Account/CovidReliefParticipant", {
          response: CovidReliefParticipantStatus
        },{
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function (response) {
          if(response.data.isSuccess == true && CovidReliefParticipantStatus != 'enrolledAlready'){
            localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus)
            localStorage.setItem("isCovidReliefStatusChecked", "true")
            _this.isFormLoading = false;
            _this.CloseModal();
            if (CovidReliefParticipantStatus == "yes")
            {
              let organizationName = _this.Account.accountType === 1
                ? _this.Account.primaryContact.firstName + ' ' + _this.Account.primaryContact.lastName + ' ' + _this.Account.primaryContact.suffix
                : _this.Account.primaryContact.legalName;
              let qparams = "?businesscompanyName=" + organizationName;
              qparams += "&email=" + _this.Account.emailAddress;
              qparams += "&cltlPeid=" + _this.Account.portalUserSalesforceId;
              qparams += "&city=" + _this.Account.primaryContact.officeLocation.city;
              qparams += "&state=" + _this.Account.primaryContact.officeLocation.state;
              qparams += "&cltlaccount=Yes";
              qparams += "&whereFrom=CLTLModal";
              console.log(qparams);
              //window.open("https://www.evfusa.org/get-involved/cltl-pick-a-day/" + qparams);
            }
// alert("Your feedback was saved.")
          } else if (response.data.isSuccess == true && CovidReliefParticipantStatus == 'enrolledAlready') {
            localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus)
            localStorage.setItem("isCovidReliefStatusChecked", "true")
            _this.isFormLoading = false;
            _this.CloseModal();
          } else {
            console.log('>> 3 ');
            localStorage.setItem("isCovidReliefStatusChecked", "true")
            alert("We got an Error on your request.")
            _this.isFormLoading = false;
            _this.CloseModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    GetAccountValues(){
      var _this = this;
      axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
        .then(function (response) {
          console.log("it ran!");
          _this.Account = response.data.raw;
          localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);
          _this.ShowStockLensTile = _this.Account.customUserPermissionFlag.includes("Show Stock Lens Tile");
//_this.ExistingStockUser = _this.Account.customUserPermissionFlag.includes("Existing Stock Lens User");
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created() {
// get covid relief status
// if enrolled, declined, show modal = false
// if remind, , show modal = true
//
    this.GetAccountValues();
  },
};
</script>
```



// WEBPACK FOOTER //
// CovidReliefModalForm.vue?3610be55